/* import __COLOCATED_TEMPLATE__ from './billing-and-payments-tab.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();